import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuoteConfigService {
  getCompanyGuidApiBaseUrl(): string {
    return environment.companyGuidApiBaseUrl;
  }

  getRfqIntakeUrl(): string {
    return environment.rfqIntakeUrl;
  }

  // Method to get configuration as a script tag content
  getQuoteScriptConfig(): string {
    return `
      window.QUOTE_CONFIG = {
        apiBasePath: "${this.getCompanyGuidApiBaseUrl()}",
        rfqIntakeUrl: "${this.getRfqIntakeUrl()}"
      };
    `;
  }
}
